import { LabeledValue } from "antd/es/select";
import { omit } from "lodash-es";
import { IntlShape } from "react-intl";

import RecurringIntervalType from "@app/enum/RecurringIntervalType";

import { recurringIntervalMessages } from "../component/messages";

export const predefinedIntervals = Object.values<RecurringIntervalType>(RecurringIntervalType);

export const getRecurIntervalOptions = (
  intl: IntlShape,
  recurIntervalType: RecurringIntervalType
): LabeledValue[] => {
  const availableRecurringIntervals =
    recurIntervalType === RecurringIntervalType.NEVER
      ? [[RecurringIntervalType.NEVER, RecurringIntervalType.NEVER]]
      : (Object.entries(omit(RecurringIntervalType, RecurringIntervalType.NEVER)) as [
          RecurringIntervalType,
          RecurringIntervalType,
        ][]);
  return availableRecurringIntervals.map<LabeledValue>(([name, value]) => ({
    key: name,
    label: intl.formatMessage(recurringIntervalMessages[value]),
    value,
  }));
};
